import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Box, Typography, Button } from "@mui/material";
import { signOut } from "firebase/auth";
import { auth } from "../services/firebase";
import withAuthGuard from "../hoc/withAuthGuard";

const DashboardPage: React.FC = () => {
  const { user, loading } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.href = "/auth"; // リダイレクト
    } catch (error) {
      console.error("ログアウトに失敗しました:", error);
    }
  };

  if (loading) {
    return <p>読み込み中...</p>;
  }

  if (!user) {
    return <Navigate to="/auth" />;
  }

  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "auto",
        mt: 5,
        p: 3,
        borderRadius: 1,
        boxShadow: 3,
        backgroundColor: "white",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        ダッシュボード
      </Typography>
      <Typography variant="body1" gutterBottom>
        ログイン後のダッシュボードページです。ここに提供者向けのデータや機能を表示します。
      </Typography>
      <Button variant="contained" color="primary" sx={{ mt: 2, mr: 2 }}>
        機能を見る
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        sx={{ mt: 2 }}
        onClick={handleLogout}
      >
        ログアウト
      </Button>
    </Box>
  );
};

export default withAuthGuard(DashboardPage);
